import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import inquirySevice from "../../../services/inquirySevice";
import { instanceToken } from "../../../utils/constant";
import { formatDetailDate } from "../../../utils/detailUtils";

export default function Inquiry() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [inquiry, setInquiry] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchInquiryData = async () => {
      try {
        const res = await inquirySevice.getAllInquiryData(instanceToken.token);
        setData(res.data.inquiry);
      } catch (error) {
        console.error(error);
      }
    };

    fetchInquiryData();
    fetchInquiry(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchInquiry = async (limit, offsetValue) => {
    try {
      const res = await inquirySevice.getAllInquiry(
        instanceToken.token,
        limit,
        offsetValue
      );
      setInquiry(res.data.inquiry);
      setCount(res.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const exportRows = (rows) => {
    const dataToExport = rows.map((u) => ({
      InquiryID: u.id,
      ProductName: u.product_name,
      InquirerName: u.inquirer_name,
      PhoneNumber: u.phone_number,
      Message: u.message,
    }));

    const xls = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, xls, "Inquiries");
    XLSX.writeFile(wb, `${new Date().toISOString()}.xlsx`);
  };

  const openDetail = (row) => navigate(`/inquiry/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "product_name",
      label: "Product Name",
      render: (row) => <TruncatedCell value={row.product_name} />,
    },
    {
      id: "inquirer_name",
      label: "Inquirer Name",
      render: (row) => <TruncatedCell value={row.inquirer_name} />,
    },
    {
      id: "phone_number",
      label: "Phone Number",
      render: (row) => <TruncatedCell value={row.phone_number} />,
    },
    {
      id: "message",
      label: "Message",
      render: (row) => <TruncatedCell value={row.message} />,
    },
    {
      id: "created_at",
      label: "Created Date",
      render: (row) => formatDetailDate(row.created_at) || "N/A",
    },
    {
      id: "updated_at",
      label: "Updated At",
      render: (row) => formatDetailDate(row.updated_at) || "N/A",
    },
  ];

  return (
    <DataListPage
      title="Inquiry"
      rows={inquiry || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[10, 25]}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      headerActions={[
        { label: "Export to Excel", onClick: () => exportRows(inquiry || []) },
        { label: "Export All Excel", onClick: () => exportRows(data) },
      ]}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!inquiry}
    />
  );
}
